import { render, staticRenderFns } from "./upload-demo.vue?vue&type=template&id=74129d64&scoped=true&"
import script from "./upload-demo.vue?vue&type=script&lang=js&"
export * from "./upload-demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74129d64",
  null
  
)

export default component.exports